package com.schoolconnect.app.datasource.network.response

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class SystemHealthResponse(
    val timestamp: String = "",
    val status: String = "",
    val services: SystemHealthServicesResponse = SystemHealthServicesResponse()
)

@Serializable
data class SystemHealthServicesResponse(
    val api: SystemHealthApiServiceResponse = SystemHealthApiServiceResponse(),
    val database: SystemHealthDatabaseServiceResponse = SystemHealthDatabaseServiceResponse(),
    @SerialName("push_notifications")
    val pushNotifications: SystemHealthProviderServiceResponse = SystemHealthProviderServiceResponse(),
    @SerialName("sms_delivery")
    val smsDelivery: SystemHealthProviderServiceResponse = SystemHealthProviderServiceResponse(),
    @SerialName("server_uptime")
    val serverUptime: SystemHealthUptimeServiceResponse = SystemHealthUptimeServiceResponse(),
    @SerialName("backup_status")
    val backupStatus: SystemHealthBackupServiceResponse = SystemHealthBackupServiceResponse()
)

@Serializable
data class SystemHealthApiServiceResponse(
    val status: String = "",
    @SerialName("response_time_ms")
    val responseTimeMs: Int? = null
)

@Serializable
data class SystemHealthDatabaseServiceResponse(
    val status: String = "",
    val error: String? = null
)

@Serializable
data class SystemHealthProviderServiceResponse(
    val status: String = "",
    val provider: String? = null
)

@Serializable
data class SystemHealthUptimeServiceResponse(
    val seconds: Long? = null,
    @SerialName("human_readable")
    val humanReadable: String = ""
)

@Serializable
data class SystemHealthBackupServiceResponse(
    val status: String = "",
    @SerialName("last_backup")
    val lastBackup: String? = null
)
